<template lang="pug">

</template>

<script>
import  { mapActions, mapGetters } from 'vuex'
import * as Sentry from '@sentry/vue'
import {isMarketingMerchantApp} from "@/utils";
export default {
  name: "SignOut",
  data: () => ({
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
  },
  mounted () {
    try {
      localStorage.setItem('yz_login_company', this.company.slug)
      this.$store.commit('user/setUser', null)
      this.$store.commit('user/setMember', null)
      this.updateCompany(null)
      localStorage.removeItem('yz_top_bar_items')
      // localStorage.removeItem('yz_customer_fields')
      // localStorage.removeItem('yz_donor_fields')
      // localStorage.removeItem('yz_patient_fields')
      // localStorage.removeItem('yz_appointment_fields')
      // localStorage.removeItem('yz_appointment_schedule_fields')
      // localStorage.removeItem('yz_appointment_request_fields')
      // localStorage.removeItem('yz_review_invitation_fields')
      // localStorage.removeItem('yz_registration_fields')
      // localStorage.removeItem('yz_inventory_fields')
      // localStorage.removeItem('yz_service_fields')
      // localStorage.removeItem('yz_package_fields')
      // localStorage.removeItem('yz_stocktake_fields')
      // localStorage.removeItem('yz_location_fields')
      // localStorage.removeItem('yz_user_fields')
      // localStorage.removeItem('yz_billing_fields')
      // localStorage.removeItem('yz_inventory_invoice_fields')
      // localStorage.removeItem('yz_visit_summary_sections')
      // localStorage.removeItem('yz_vital_signs_sections')
      // localStorage.removeItem('yz_all_panel_invoice_fields')
      // localStorage.removeItem('yz_offer_fields')
      // localStorage.removeItem('yz_loyalty_fields')
      Sentry.setUser(null)
    } catch {
      // 
    }
    if (this.$subdomain) {
      document.location.href = `https://app.${process.env.VUE_APP_BASE_DOMAIN}/signin`
    } else {
      if (this.$route?.query?.username) {
        this.$router.push('/signin/clinic')
      } else {
        if (isMarketingMerchantApp(this.$route)) {
          this.$router.push('/signin/merchant-app')
          return
        }
        this.$router.push('/signin')
      }
    }
  },
  methods: {
    ...mapActions([
      'updateCompany'
    ])
  }
}
</script>

<style lang="scss" scoped>

</style>